/* @flow */
import CardLogo from './CardLogo.jsx';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import cx from 'classnames';
import FlexibleBlock from 'components/FlexibleBlock.jsx';
import Glyph from 'components/Glyph.jsx';
import ManagerItemCard from './ManagerItemCard.jsx';
import Menu from 'components/Menu.jsx';
import MenuButton from 'components/MenuButton.jsx';
import ModalMenuItem from 'components/ModalMenuItem.jsx';
import PaymentSource from 'entities/PaymentSource';
import PaymentSourceActions from 'payments/actions/PaymentSourceActions';
import React from 'react';
import ToastActions from 'actions/ToastActions';

import './styles/PaymentCardsManagerItem.scss';

export default React.createClass({
  propTypes: {
    paymentSource: React.PropTypes.instanceOf(PaymentSource).isRequired,
  },

  renderMenuButton() {
    const confirmDialog = (
      <ConfirmDialog
        title="Are you sure you want to delete this payment card?"
        actionButtonText="Yes"
        cancelButtonText="No"
        onConfirm={() => {
          PaymentSourceActions
          .delete(this.props.paymentSource)
          .then(
            () => ToastActions.showSuccessToast('Payment card removed'),
            () => ToastActions.showDefaultErrorToast(),
          );
        }}
      />
    );

    const menu = (
      <Menu>
        <ModalMenuItem modal={confirmDialog}>
          Remove Card
        </ModalMenuItem>
      </Menu>
    );

    return (
      <MenuButton
        alignment="right"
        placement="bottom"
        menu={menu}
        size="medium"
        level="icon">
        <Glyph name="ellipses" solo />
      </MenuButton>
    );
  },

  render() {
    return (
      <ManagerItemCard className={cx('PaymentCardsManagerItem', this.props.className)}>
        <FlexibleBlock flex="left">
          <div>
            <FlexibleBlock flex="right">
              <div className="PaymentCardsManagerItem-logo">
                <CardLogo paymentSource={this.props.paymentSource} />
              </div>
              <div>
                <div className="PaymentCardsManagerItem-title">
                  {this.props.paymentSource.getBrand()} ending in {' '}
                  {this.props.paymentSource.getLastFourDigit()}
                </div>

                <table className="PaymentCardsManagerItem-table">
                  <tbody>
                    <tr>
                      <td>Expiration Date:</td>
                      <td>{this.props.paymentSource.getExpirationDate()}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </FlexibleBlock>
          </div>

          <div className="PaymentCardsManagerItem-actions">
            {this.renderMenuButton()}
          </div>
        </FlexibleBlock>
      </ManagerItemCard>
    );
  },
});



// WEBPACK FOOTER //
// ./src/payments/components/PaymentCardsManagerItem.jsx